import { Ellipsis } from '@janeapp/burrito-design-system/icons';
import {
  Menu,
  MenuTrigger,
  MenuItem,
  Popover,
  Button,
} from 'react-aria-components';
import { MENU_ITEMS } from '~/utilities/constants';

export const NavigationMenu = () => {
  return (
    <MenuTrigger>
      <Button
        className="focus-ring right-0 rounded p-[10px] text-neutral-80 hover:bg-brand-10 hover:text-brand-90"
        aria-label="Help menu"
        aria-haspopup="menu"
      >
        <Ellipsis aria-label="More options menu" />
      </Button>
      <Popover className="fill-mode-forwards entering:animate-in entering:fade-in entering:zoom-in-95 exiting:animate-out exiting:fade-out exiting:zoom-out-95">
        <Menu className="focus-ring cursor-pointer rounded bg-white p-0.5 text-md shadow-md outline-none">
          {MENU_ITEMS.map((item) => (
            <MenuItem
              key={item.label}
              className={`focus:focus-ring-menu-item rounded px-5 py-3 active:bg-neutral-20 hover:bg-neutral-10 hover:text-brand-80`}
              onAction={() => {
                window.open(item.href, '_blank', 'noopener,noreferrer');
              }}
            >
              {item.label}
            </MenuItem>
          ))}
        </Menu>
      </Popover>
    </MenuTrigger>
  );
};
